import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../../Common/Constants";
import { types } from "../../../Redux/Actions/types";
import TextField from "../../Common/Fields/TextField";
import ButtonCustom from "../../Common/Fields/ButtonCustom";
import {
  movementPatternInsert,
  movementPatternList,
  movementPatternUpdate,
} from "../../../Redux/Actions";
import usePermissions from "../../Common/Functions/usePermissions";

const MovementPatternForm = () => {
  const dispatch = useDispatch();
  const { movementPatternSingle } = useSelector(
    (state) => state.MovementPattern
  );
  // Permissions
  const addPermission = usePermissions(Constants.permission.MECHANICS_ADD);
  const editPermission = usePermissions(Constants.permission.MECHANICS_EDIT);

  // Initial values to movement pattern form
  const [initialValues, setInitialValues] = useState({
    name: "",
  });

  // Validations for movement pattern form
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill movement pattern form
    if (movementPatternSingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (movementPatternSingle[key]) {
          editValue[key] = movementPatternSingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [movementPatternSingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update movement pattern API
        let submitFunc = movementPatternInsert(values);
        if (movementPatternSingle._id) {
          values.id = movementPatternSingle._id;
          submitFunc = movementPatternUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.message,
            });
            dispatch({ type: types.MOVEMENT_PATTERN_SINGLE, payload: "" });
            dispatch({ type: types.MOVEMENT_PATTERN_FORM_MODEL, payload: "" });
          }
          dispatch(movementPatternList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="name"
              className="form-control"
              errors={touched?.name ? errors?.name : undefined}
              touched={touched?.name}
              label={Constants.name}
            />
          </div>
          {((addPermission && !movementPatternSingle?._id) ||
            (editPermission && movementPatternSingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default MovementPatternForm;
